import { createContext } from "react"

export const AdminContext = createContext<{isInterfaceAdmin: boolean}>({ isInterfaceAdmin: false});